const markerPath = process.env.PUBLIC_URL + '/images/campuses/';

const interlake = markerPath + 'interlake.svg',
  manitou = markerPath + 'manitou.svg',
  ndc = markerPath + 'ndc.svg',
  pgi = markerPath + 'pgi.svg',
  portage = markerPath + 'portage.svg',
  roblin = markerPath + 'roblin.svg',
  steinbach = markerPath + 'steinbach.svg',
  stevensonSouthport = markerPath + 'stevensonSouthport.svg',
  stevensonWinnipeg = markerPath + 'stevensonAirport.svg',
  winkler = markerPath + 'winkler.svg';

const campuses = [
  {
    id: 'roblin',
    name: 'The Roblin Centre',
    phone: '204-949-8305',
    lat: 49.900799,
    lng: -97.14176,
    icon: roblin,
  },
  {
    id: 'edc',
    name: 'Exchange District Campus',
    lat: 49.900799,
    lng: -97.14176,
  },
  {
    id: 'manitou',
    name: 'Manitou a bi Bii daziigae',
    lat: 49.901138,
    lng: -97.1415,
    icon: manitou,
  },
  {
    id: 'interlake',
    name: 'Interlake and Peguis - Fisher River Campus',
    phone: '204-785-5328',
    lat: 50.15376,
    lng: -96.89008,
    icon: interlake,
  },
  {
    id: 'ndc',
    name: 'Notre Dame Campus',
    phone: '204-632-2323',
    lat: 49.92,
    lng: -97.21122,
    icon: ndc,
  },
  {
    id: 'pgi',
    name: 'Paterson GlobalFoods Institute',
    phone: '204-631-3381',
    lat: 49.8992,
    lng: -97.13955,
    icon: pgi,
  },
  {
    id: 'portage',
    name: 'Portage Campus',
    phone: '204-856-1915',
    lat: 49.97117,
    lng: -98.282879,
    icon: portage,
  },
  {
    id: 'steinbach',
    name: 'Steinbach Campus',
    phone: '204-320-2500',
    lat: 49.532335,
    lng: -96.672925,
    icon: steinbach,
  },
  {
    id: 'stevensonSouthport',
    name: 'Stevenson Campus (Southport)',
    phone: '204-428-6300',
    lat: 49.91485,
    lng: -98.27381,
    icon: stevensonSouthport,
  },
  {
    id: 'stevensonWinnipeg',
    name: 'Stevenson Campus (Winnipeg)',
    phone: '204-945-6001',
    lat: 49.904309,
    lng: -97.250916,
    icon: stevensonWinnipeg,
  },
  {
    id: 'winkler',
    name: 'Winkler Campus',
    phone: '204-325-9672',
    lat: 49.186529,
    lng: -97.938915,
    icon: winkler,
  },
];

const campusesForMapsTopBar = campuses
  .filter(({ id }) => !['roblin', 'manitou', 'pgi'].includes(id))
  .map(({ id, name, lat, lng }) => ({
    id,
    name,
    lat,
    lng,
  }));

const campusesWithPhone = campuses
  .filter(({ id }) => !['edc', 'manitou'].includes(id))
  .map(({ id, name, phone }) => ({
    id,
    name,
    phone,
  }));

const campusMarkers = campuses
  .filter(({ icon }) => icon)
  .map((campus) => ({ ...campus, cssClassName: 'campus', info: campus.name }));

const campusByID = (id) => campuses.find((campus) => campus.id === id);

export {
  campuses,
  campusesForMapsTopBar,
  campusMarkers,
  campusesWithPhone,
  campusByID,
};
